import { render, staticRenderFns } from "./ServersOverview.vue?vue&type=template&id=67e48ff0&"
import script from "./ServersOverview.vue?vue&type=script&lang=js&"
export * from "./ServersOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports